import React, { ReactNode, useCallback } from 'react';
import { useSnackbar, VariantType } from 'notistack';

// Data
import { FAILURE_SNACKBAR_MS } from '../snackbar.constants';
import { useSnackbarDismissAction } from './use-snackbar-dismiss-action';

// Components
import { IntlMsg } from '../../components/_core/IntlMsg/intl-msg.component';
import { IIntlMessage } from '../../components/_core/IntlMsg/intl-msg.types';

// Shows an i18n message as a dismissible snackbar; without a variant it is an error held for the failure duration.
// `values` fills the message's ICU placeholders, so a caller can name what failed rather than describe it generically.
export const useIntlSnackbar = () => {
  const { enqueueSnackbar } = useSnackbar();
  const dismissAction = useSnackbarDismissAction();

  return useCallback((
    message: IIntlMessage,
    variant: VariantType = 'error',
    autoHideDuration = FAILURE_SNACKBAR_MS,
    values?: Record<string, ReactNode>
  ) => {
    enqueueSnackbar(<IntlMsg {...message} values={values} />, { variant, autoHideDuration, action: dismissAction });
  }, [enqueueSnackbar, dismissAction]);
};
